import * as React from 'react'
import { useFiltersApi } from '@/hooks'
import { useAnalyticsFiltersStore } from '../../stores/useAnalyticsFiltersStore/useAnalyticsFiltersStore'
import { ReportFiltersValues } from '../../stores/useAnalyticsFiltersStore/types'

type UseTotalUsnsParams = {
    nodeIds?: string
    commodityTypeId?: string
    providerIds?: string
    contractIds?: string
    panIds?: string
    facilityIds?: string
    tagIds?: string
    activeFilters?: ReportFiltersValues
}

export const useTotalUsns = (params: UseTotalUsnsParams) => {
    const { useUSNsQuery } = useFiltersApi()
    const analyticsActiveFilters = useAnalyticsFiltersStore(
        (state) => state.activeFilters
    )

    // Use provided activeFilters or fall back to analytics store
    const activeFilters = params.activeFilters ?? analyticsActiveFilters

    const {
        data: allUsns,
        isLoading,
        isFetching,
        isFetched,
    } = useUSNsQuery({
        'nodeIds[]': params.nodeIds,
        'commodityTypeIds[]': params.commodityTypeId,
        'providerIds[]': params.providerIds,
        'contractIds[]': params.contractIds,
        'panIds[]': params.panIds,
        'facilityIds[]': params.facilityIds,
        'tagIds[]': params.tagIds,
    })

    const selectedUsns = React.useMemo(
        () => activeFilters.usn ?? [],
        [activeFilters.usn]
    )

    const totalUsns = React.useMemo(() => {
        if (selectedUsns.length > 0) {
            return selectedUsns.length
        }
        const uniqueUsns = new Set(
            (allUsns ?? []).map((usn) => usn.usnAccountId)
        )
        return uniqueUsns.size
    }, [selectedUsns, allUsns])

    return {
        totalUsns,
        isLoading,
        isFetching,
        isFetched,
    }
}
